/**
 * Meta event helpers for browser + server (CAPI) deduplication.
 * Generate one event_id per action, pass it to fbq() as { eventID } AND to the
 * backend, which sends the same event_name + event_id to the Conversions API.
 */

export function newEventId(prefix: string): string {
  const rand =
    typeof crypto !== 'undefined' && 'randomUUID' in crypto
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  return `${prefix}-${rand}`;
}

/** Read the non-HttpOnly _fbp / _fbc cookies set by the Meta Pixel. */
export function getFbCookies(): { fbp?: string; fbc?: string } {
  const result: { fbp?: string; fbc?: string } = {};
  const cookies = typeof document !== 'undefined' ? document.cookie.split(';') : [];
  for (const c of cookies) {
    const [rawKey, ...rest] = c.trim().split('=');
    if (rawKey === '_fbp') result.fbp = rest.join('=');
    if (rawKey === '_fbc') result.fbc = rest.join('=');
  }
  return result;
}
